import Repository from './Repository.js';

class SalesRepository extends Repository {
    async getSales(query) {
        return await this.get('sales', query);
    }
}

export default new SalesRepository();
